import { useState } from 'react'
import { useListContext } from 'react-admin'

import { Circle } from './Circle'
import { lightTheme } from '../../config/theme'

const SearchCircle = ({ initialCenter }) => {
  const [radius, setRadius] = useState(1000)
  const [center, setCenter] = useState(initialCenter)
  const { filterValues, setFilters } = useListContext()

  const onRadiusChange = (newRadius) => {
    setRadius(newRadius)
    setFilters({ ...filterValues, search_radius: newRadius }, undefined, true)
  }

  const onCenterChange = (newCenter) => {
    setCenter(newCenter)
    setFilters({ ...filterValues, lat: newCenter.lat(), lng: newCenter.lng() }, undefined, true)
  }

  return (
    <Circle
      center={center}
      radius={radius}
      onCenterChanged={onCenterChange}
      onRadiusChanged={onRadiusChange}
      strokeColor="#0c4cb3"
      fillColor={lightTheme.palette.primary[500]}
      fillOpacity={0.2}
      editable
    />
  )
}

export default SearchCircle
